import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/landing/LandingNavbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(true);

  const handleLoginClick = () => {
    setMobileMenuOpen(false);
    navigate("/login");
  };

  const handleRegisterClick = () => {
    setMobileMenuOpen(false);
    navigate("/register");
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setMobileDropdownOpen(!mobileDropdownOpen);
  };

  return (
    <nav className="nav-navbar">
      <div className="nav-left">
        <a href="/" className="nav-logo-link">
          <img
            src="/images/Logo1-white.png"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = "/image/Logo1-white.png";
            }}
            alt="Fotographiya"
            className="nav-logo"
          />
        </a>
      </div>

      {/* Main Navigation Links (Desktop bar + Mobile Slidebar) */}
      <ul className={`nav-links ${mobileMenuOpen ? "nav-active" : ""}`} id="mobile-nav">
        <li className={`dropdown ${mobileDropdownOpen ? "is-expanded" : ""}`}>
          <button
            type="button"
            className="dropdown-trigger-btn"
            onClick={toggleDropdown}
            aria-expanded={mobileDropdownOpen}
            aria-haspopup="true"
          >
            <span>Solutions & Use-cases</span>
            <span className="dropdown-arrow">{mobileDropdownOpen ? "▴" : "▾"}</span>
          </button>
          <ul className={`dropdown-menu ${mobileDropdownOpen ? "mobile-show" : "mobile-hide"}`}>
            <li onClick={() => setMobileMenuOpen(false)}>For Photographers</li>
            <li onClick={() => setMobileMenuOpen(false)}>For Weddings</li>
            <li onClick={() => setMobileMenuOpen(false)}>For Parties & Celebrations</li>
            <li onClick={() => setMobileMenuOpen(false)}>For Corporates</li>
            <li onClick={() => setMobileMenuOpen(false)}>For Colleges</li>
            <li onClick={() => setMobileMenuOpen(false)}>For Events</li>
          </ul>
        </li>

        <li className="nav-item">
          <a
            href="https://www.fotographiya.com/aboutUs"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMobileMenuOpen(false)}
          >
            About Us
          </a>
        </li>
        <li className="nav-item">
          <a
            href="https://www.fotographiya.com/contactUs"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMobileMenuOpen(false)}
          >
            Contact Us
          </a>
        </li>
        <li className="nav-item">
          <a
            href="https://www.fotographiya.com/blog"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMobileMenuOpen(false)}
          >
            Blog
          </a>
        </li>

        {/* Action Buttons inside slidebar for mobile */}
        <li className="mobile-menu-footer">
          <button
            type="button"
            className="nav-btn-mobile-login"
            onClick={handleLoginClick}
          >
            Login
          </button>
          <button
            type="button"
            className="nav-btn-mobile-register"
            onClick={handleRegisterClick}
          >
            Register
          </button>
        </li>
      </ul>

      {/* Outer Action Buttons - Always Visible on BOTH Mobile & Desktop outside slidebar */}
      <div className="nav-actions">
        <button
          type="button"
          className="nav-btn-header nav-btn-login"
          onClick={handleLoginClick}
          aria-label="Login"
        >
          Login
        </button>
        <button
          type="button"
          className="nav-btn-header nav-btn-register"
          onClick={handleRegisterClick}
          aria-label="Register"
        >
          Register
        </button>

        {/* Mobile Hamburger Toggle Button */}
        <button
          type="button"
          className={`nav-mobile-toggle ${mobileMenuOpen ? "is-open" : ""}`}
          onClick={toggleMobileMenu}
          aria-expanded={mobileMenuOpen}
          aria-controls="mobile-nav"
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
